<template>
  <section class="page">
    <main>
      <div class="header">
        <div class="headerright">
           
          <a-button type="primary" shape="round" @click="showModal">
            <template #icon>
              <file-add-outlined />
            </template>
            内容新增
          </a-button>
          <a-button type="primary" shape="round" @click="showCategory">
            <template #icon>
              <file-add-outlined />
            </template>
            视频中心分类管理
          </a-button>
          <a-button type="primary" shape="round" @click="showClue">
            <template #icon>
              <file-add-outlined />
            </template>
            线索管理
          </a-button>
          <a-modal v-model:visible="visible" :title="newstitle" width="100%" centered
        wrap-class-name="full-modal"  @cancel="close">
    <a-form :label-col="labelCol" :model="form">
        
        <a-row>
            <a-col :span="12"> 
                <a-form-item label="发布时间" required v-bind="validateInfos.stamp">
                    <a-date-picker show-time placeholder="Select Time" v-model:value="form.stamp" />
                </a-form-item>
            </a-col>
            <a-col :span="12"> 
                <a-form-item label="发布人" required v-bind="validateInfos.publishUser">
                    <a-input placeholder="系统管理员" v-model:value="form.publishUser" />
                </a-form-item>
            </a-col>
        </a-row>

        <!-- 文件分类下拉框 -->
        <a-form-item label="文件分类" required v-bind="validateInfos.fileType">
            <a-select v-model:value="form.fileType" placeholder="请选择文件分类" > 
                <a-select-option v-for="category in categories" :key="category.id" :value="category.id" >
                    {{ category.name }}
                </a-select-option>
            </a-select>
        </a-form-item>

        <a-form-item label="视频分类"  v-if="form.fileType == 1">
            <a-select v-model:value="form.childFileType" placeholder="请选择视频分类" > 
                <a-select-option v-for="category in childCategories" :key="category.id" :value="category.id" >
                    {{ category.name }}
                </a-select-option>
            </a-select>
        </a-form-item>

        <a-form-item label="文件名称" required v-bind="validateInfos.title">
            <a-input placeholder="title" v-model:value="form.title" />
        </a-form-item>
        
        <a-form-item label="详情描述" v-bind="validateInfos.remark">
            <a-input placeholder="description" v-model:value="form.remark" />
        </a-form-item>
        
        <a-row>
            <a-col :span="12">
                <a-form-item label="文件封面" required v-bind="validateInfos.coverImageFiles">
                    <file-upload ref="ResourceFileUpload" :maxLength="1" :fileList="form.coverImageFiles" :relationId="form.id"
                        relationModule="ResourceImageFiles" fileType="image" uploader="admin" :isMultiple="false"
                        @upload-complete="filesPhotosComplete" @del-file="NewsPhotosDel" @add-file="newsPhotosAdd" />
                </a-form-item>
            </a-col>
            <a-col :span="12">
                <a-form-item label="文件内容" required v-bind="validateInfos.contentFiles">
                    <file-upload ref="ResourceVideoUpload" :maxLength="1" :fileList="form.contentFiles" :relationId="form.id"
                        relationModule="ResourceVideoFiles" fileType="file" uploader="admin" :isMultiple="false"
                        @upload-complete="filesVideoComplete" @del-file="resourceVideoDel" @add-file="resourceVideoAdd" />
                </a-form-item>
            </a-col>
        </a-row>
        
    </a-form>
    <template #footer>
        <a-button key="back" type="primary" @click="handleAdd" v-if="isAdd">保存并新增</a-button>
        <a-button key="submit" type="primary" @click="handleClose">保存并关闭</a-button>
        <a-button key="cancel" type="primary" @click="handleCancel">取消</a-button>
    </template>
</a-modal>

        </div>

        <strong>资源中心管理</strong>
      </div>
      <div class="pagemain">
        <div class="tblbox">
          <div class="searchbox">
            <a-form layout="inline">
              <a-form-item label="文件名称">
                <a-input placeholder="请输入" v-model:value="requestData.title" />
              </a-form-item>
              <a-form-item label="发布时间">
                <a-range-picker v-model:value="requestData.stamp" />
              </a-form-item>
              <a-form-item>
                <a-button type="primary" @click="search">查询</a-button>
              </a-form-item>
            </a-form>
          </div>
          <a-table size="small" :dataSource="resourceList" :columns="columns" :scroll="{ y: 'calc(100vh - 280px)' }"
            :pagination="pagination" @change="handleTableChange"
            :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)">
            <template #bodyCell="{ column, record, index }">
              <template v-if="column.key === 'sn'">
                {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
              </template>
              <template v-if="column.key === 'title'">
                {{ record.title }}
              </template>
               <template v-if="column.key === 'fileType'">
                {{   categories.find(cat => cat.id === record.fileType)?.name}}
              </template>
                <template v-if="column.key === 'childFileType'">
                {{   childCategories.find(cat => cat.id === record.childFileType)?.name}}
              </template>
            
              <template v-if="column.key === 'operation'">
                <a-dropdown placement="bottomRight">
                  <a-space>
                    <!-- <a href="javascript:;">查看</a> -->
                    <a href="javascript:;" @click.prevent="editModel(record)">修改</a>
                    <a-popconfirm placement="left" title="确认删除?" ok-text="确认" cancel-text="取消"
                      @confirm="removeResource(record)">
                      <a title="删除" href="javascript:;" style="margin-left: 5px;">删除</a>
                    </a-popconfirm>
                  </a-space>
                </a-dropdown>
              </template>
            </template></a-table>
        </div>
      </div>
    </main>
  </section>
</template>

<script setup>
import '@wangeditor/editor/dist/css/style.css';
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import useResource from '@/composables/useResource';
import fileUpload from '@/components/file.upload.vue';

import { onBeforeUnmount, ref, shallowRef, onMounted, computed, reactive, defineComponent, getCurrentInstance, nextTick } from 'vue';
import { FileAddOutlined, } from '@ant-design/icons-vue';
import http from '@/shared/http.service';
import { Uris, DefaultConfig } from '@/shared/const';
import dayjs from 'dayjs';
import NewsCategory from './newsCategory.vue';
const instance = getCurrentInstance();



const editorConfig = {                       // JS 语法
  MENU_CONF: {}

  // 其他属性...
};

const requestData = reactive({
  title: '',
  stamp: null,
  pageIndex: 1,
  pageSize: DefaultConfig.PageSize,
});


const { 
     getResourceList,
        resourceList,
        pagination,
        handleTableChange,
        resetFields,
        validate,
        validateInfos,
        editModal,
        handleSave,
        form,
        saved$,
        getKeyId,
        rid,
        isAdd,
        removeResource,
        currentUser,
        equEdited$,
        categories,
         childCategories,
        fetchChildCategories
} = useResource();


let mode = ref('default');
const type = ref('');

const newstitle = ref('新增资源中心');
const treeData = ref([]); // 新闻分类树
//ommounted
onMounted(() => {
//   fetchCategories();
 fetchChildCategories();
  getResourceList(requestData);
  // getNewsCategoryTree();// 新增或修改窗口的新闻分类数赋值
  saved$.subscribe(async (result) => {
    visible.value = false;
    saved(result);
    // console.log(result)
    // if (result == 'close') {
    //   await saved();
    //   // console.log(instance.refs.ResourceFileUpload)

    // }
    // if (result == 'add') {
    //   await saved();

    // }
  });

  equEdited$.subscribe((v) => {
    if (v) {
      form.id = v.id;
      form.title = v.title;
      form.content = v.content;
      form.stamp = dayjs(v.stamp);
      form.remark = v.remark;
      form.publishUser = v.publishUser;
      form.coverImageFiles = v.coverImageFiles ? v.coverImageFiles : [];
      form.contentFiles = v.contentFiles ? v.contentFiles : [];
      form.fileType = v.fileType;
      form.childFileType = v.childFileType;
      // console.log(form.contentFiles);
    }
  });
});

const index = ref(1);

const close=()=>{
    visible.value = false;
    getResourceList(requestData);
};

const saved = async (result) => {
  if (instance.refs.ResourceFileUpload.fileAttachments?.length > 0 || instance.refs.ResourceFileUpload.removedAttachments?.length > 0) {
    //新闻图片上传
    await nextTick(() => {
      instance.refs.ResourceFileUpload.uploadFile();
    }).finally(() => {

      type.value = result;
      index.value = index.value +1;
      // getResourceList(requestData);
    });
  }
 if(instance.refs.ResourceVideoUpload.fileAttachments?.length > 0 || instance.refs.ResourceVideoUpload.removedAttachments?.length > 0)
  {
    //新闻图片上传
        await nextTick(() => {
        instance.refs.ResourceVideoUpload.uploadFile();
        }).finally(() => {

        type.value = result;
         index.value = index.value +1;
        // getResourceList(requestData);
        });
    }
  // else {
  //   // getResourceList(requestData);
   
  // }
};


//文件上传完成后的事件处理
const filesPhotosComplete = (result) => {
  // console.log(result);
  // if (result) {
  //   if (result.files.length > 0) {
  //     const url = result.files[0].url;
  //     const requestModel = {
  //       coverImage: url,
  //       id: rid.value
  //     };
  //     http.post(Uris.EditResource, requestModel).subscribe((retrunresult) => {
  //       getResourceList(requestData);
  //     });
  //   }

  // }
  form.coverImageFiles = [];
  // if (type.value == 'add') {
  //   showModal();
  // }
};

const filesVideoComplete = (result) => {
//   console.log(result);
  // if (result) {
  //   if (result.files.length > 0) {
  //     const url = result.files[0].url;
  //     const requestModel = {
  //       content: url,
  //       id: rid.value
  //     };
  //     http.post(Uris.EditResource, requestModel).subscribe((retrunresult) => {
  //       getResourceList(requestData);
  //     });
  //   }

  // }
  form.contentFiles = [];
  // if (type.value == 'add') {
  //   showModal();
  // }

  if (result) {
    if (result == 'add') {
      showModal();
    }
    else {
      getResourceList(requestData);
    }
  }
};

const handleAdd = () => {
  handleSave('add');
};

const handleClose = () => {
  handleSave('close');
};

//图片上传成功后
const newsPhotosAdd = (result) => {
  // console.log(result)
  form.coverImageFiles = instance.refs.ResourceFileUpload.fileAttachments;

};

const showCategory = () => {
  window.open(`/resourceCategory`, '_blank');
};


// 删除图片
const NewsPhotosDel = (file) => {

  form.coverImageFiles = instance.refs.ResourceFileUpload.fileAttachments;
  let index = form.coverImageFiles.findIndex(item => item.uid === file.uid);
  if (index !== -1) {
    form.coverImageFiles.splice(index, 1);
  }
};

//上传视频/文件
const resourceVideoAdd= (result) => {
  // console.log(result)
  form.contentFiles = instance.refs.ResourceVideoUpload.fileAttachments;

};

//删除
const  resourceVideoDel= (file) => {

  form.contentFiles = instance.refs.ResourceVideoUpload.fileAttachments;
  let index = form.contentFiles.findIndex(item => item.uid === file.uid);
  if (index !== -1) {
    form.contentFiles.splice(index, 1);
  }
};


const search = () => {
  const searchModel = {
    title: "",
    startTime: null,
    endTime: null,
    pageIndex: 1,
    pageSize: DefaultConfig.PageSize
  };
  searchModel.title = requestData.title;
  if (requestData.stamp != null) {
    searchModel.startTime = dayjs(requestData.stamp[0]).format('YYYY-MM-DD');
    searchModel.endTime = dayjs(requestData.stamp[1]).format('YYYY-MM-DD');
  } else {

    searchModel.startTime = null;
    searchModel.endTime = null;
  }

  getResourceList(searchModel);
};


const visible = ref(false);
//新增弹出窗口
const showModal = () => {
  form.fileType = 1;  // 初始化分类为 null
//   fetchCategories(); // 加载分类数据
  resetFields();
  if (instance.refs.ResourceFileUpload) {
    instance.refs.ResourceFileUpload.fileAttachments = [];
  }
  visible.value = true;
  isAdd.value = true;
  getKeyId();//获取IdHelper生成的ID值，上传图片时需要
 
//   uploadFile();
};
const reid = ref('');
//修改弹出窗口
const editModel = (v) => {
  editModal(v);
  isAdd.value = false;
  newstitle.value = '修改资源中心';
  visible.value = true;
  rid.value = v.id;
  
//   uploadFile();
};
//保存并关闭

//关闭
const handleCancel = (e) => {
  visible.value = false;
  getResourceList(requestData);
};
const showClue = () => {
  window.open(`/clue`, '_blank');
};

const editorRef = ref(null);
const toolbarConfig = {};

const getNewsCategoryTree = () => {
  http.get(Uris.NewsCategoryTree).subscribe(result => {
    treeData.value = result;
  });
};



// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
  const editor = editorRef.value;
  if (editor == null) return;
  editor.destroy();
});


const labelCol = {
  style: {
    width: '90px',
  },
};
const columns = [
  {
    title: '序号',
    dataIndex: 'sn',
    key: 'sn',
    width: 50,
    align: 'center',
  },
  {
    title: '文件名称',
    dataIndex: 'title',
    key: 'title',
    width: 150,
  },
  {
    title: '文件类型',
    dataIndex: 'fileType',
    key: 'fileType',
    width: 150,
  },
   {
    title: '文件子类型',
    dataIndex: 'childFileType',
     key: 'childFileType',
    width: 150,
  },
  {
    title: '点击量',
    dataIndex: 'viewCount',
    key: 'viewCount',
    width: 150,
  },
  {
    title: '发布时间',
    dataIndex: 'stamp',
    key: 'stamp',
    width: 150,
  },
  {
    title: '发布人',
    dataIndex: 'publishUser',
    key: 'publishUser',
    width: 100,
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation',
    width: 150,
    align: 'center',
  },
];


</script>

<style lang="less">
.full-modal {
  .ant-modal {
    max-width: 100%;
    top: 0;
    padding-bottom: 0;
    margin: 0;
  }

  .ant-modal-content {
    display: flex;
    flex-direction: column;
    height: calc(100vh);
  }

  .ant-modal-body {
    flex: 1;
  }
}

.rs-postbox-item:not(:last-child) {
  margin-bottom: 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.11);
  padding-bottom: 20px;
}
@media only screen and (max-width: 575px) {
  .rs-postbox-item:not(:last-child) {
    margin-bottom: 20px;
    padding-bottom: 20px;
  }
}
.rs-postbox-content {
  padding-top: 20px;
}
</style>
